import { BaseAPI } from '@services/api';

class API extends BaseAPI {
  constructor() {
    super('settings/settings');
  }
}

export default new API();
